import { render, staticRenderFns } from "./children.vue?vue&type=template&id=744016c9&scoped=true"
import script from "./children.vue?vue&type=script&lang=js"
export * from "./children.vue?vue&type=script&lang=js"
import style0 from "./children.vue?vue&type=style&index=0&id=744016c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744016c9",
  null
  
)

export default component.exports